var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.0028L14.5875 12.0028L12.2987 14.2892C11.9087 14.6788 11.9087 15.3182 12.2987 15.7078C12.6887 16.0974 13.3187 16.0974 13.7087 15.7078L17.7075 11.713C18.0975 11.3234 18.0975 10.6941 17.7075 10.3045L13.7113 6.29221C13.3213 5.9026 12.6913 5.9026 12.3013 6.29221C11.9113 6.68181 11.9113 7.31118 12.3013 7.70079L14.5875 10.0048L5 10.0048C4.45 10.0048 4 10.4543 4 11.0038C4 11.5532 4.45 12.0028 5 12.0028Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/ArrowRightIcon.81ee4f72a034a62c5b3ca2cadbc86acc.svg";
export { ForwardRef as ReactComponent };